define("ember-intl/-private/store/translation", ["exports", "ember-intl/-private/utils/flatten", "ember-intl/-private/utils/parse"], function (_exports, _flatten, _parse) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
  /**
   * @remarks
   * `tests/unit/helpers/t-test.ts` has a test that asserts that numbers are
   * acceptable as translations and converted to strings.
   */

  class Translation {
    get localeName() {
      return this._localeName;
    }
    constructor(localeName) {
      _defineProperty(this, "translations", new Map());
      _defineProperty(this, "asts", new Map());
      _defineProperty(this, "_localeName", void 0);
      this._localeName = localeName;
    }
    addTranslations(translations) {
      const flatTranslations = (0, _flatten.default)(translations);
      for (const key in flatTranslations) {
        let translation = flatTranslations[key];

        // If it's not a string, coerce it to one.
        if (typeof translation !== 'string') {
          translation = `${translation}`;
        }
        this.translations.set(key, translation);
        this.asts.set(key, (0, _parse.default)(translation));
      }
    }
    find(key) {
      if (this.has(key)) {
        return {
          ast: this.asts.get(key),
          original: this.translations.get(key)
        };
      }
    }
    has(key) {
      return this.translations.has(key);
    }
  }
  var _default = _exports.default = Translation;
});